__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/366dbb8/packs/";